import { ContentStatus, ContentType } from "./contentCardTypes";

export const buildLessonButtonText = (type: ContentType, status: ContentStatus): string => {
  let buttonText = "";

  switch (status) {
    case "inProgress":
      buttonText = "Continue ";
      break;
    case "completed":
      buttonText = "Retake ";
      break;
    case "notStarted":
    default:
      buttonText = "Start ";
  }

  switch (type) {
    case "video":
    case "breakfix":
      buttonText += "Lesson";
      break;
    case "codingChallenge":
      buttonText += "Coding Challenge";
      break;
    case "path":
      buttonText += "Path";
      break;
    case "exercise":
      buttonText += "Exercise";
      break;
    default:
      buttonText += "Content"; // Fallback for unknown types (should not happen)
  }

  return buttonText;
};

export const getLessonBadgeSvg = (
  type: ContentType | undefined,
  status: ContentStatus
): string | null => {
  if (!type) return null;
  const badgeFolder = status === "completed" ? "complete" : "incomplete";

  try {
    return new URL(`../../../assets/badges/${badgeFolder}/${type}.svg`, import.meta.url).href;
  } catch {
    return null;
  }
};
